<template>
  <footer
    class="relative flex flex-col items-center justify-center gap-16 sm:gap-20 p-[2%]"
  >
    <div class="relative w-full">
      <div
        class="flex flex-col w-full max-w-5xl mx-auto gap-16 md:pl-[10%]"
      >
        <!-- First row: Socials and Resources -->
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-6 flex flex-col items-center md:items-start">
            <p
              class="heading-5 border-flax-smoke-400 w-fit border-b pb-2 font-bold"
            >
              Socials
            </p>
            <div class="mt-2 space-y-1">
              <p v-for="i in socialLinks" :key="i.label" class="heading-6">
                <Link
                  class="h-6 font-medium tracking-wider lowercase"
                  :label="i.label"
                  :url="i.url"
                />
              </p>
            </div>
          </div>

          <div class="col-span-6 flex flex-col items-center md:items-start">
            <p
              class="heading-5 border-flax-smoke-400 w-fit border-b pb-2 font-bold"
            >
              Resources
            </p>
            <div class="mt-2 space-y-1">
              <p v-for="i in resourceLinks" class="heading-6">
                <Link
                  class="font-medium tracking-wider lowercase"
                  :label="i.label"
                  :url="i.url"
                  :target="i.label === 'Resume' ? '_blank' : undefined"
                />
              </p>
            </div>
          </div>
        </div>

        <!-- Second row: Credits, Time, and Arrow -->
        <div class="grid grid-cols-12 items-start gap-4">
          <div class="col-span-12 md:col-span-6 flex flex-col items-center md:items-start">
            <h6 class="text-sm sm:heading-6 md:heading-5 leading-none font-bold text-center md:text-left whitespace-nowrap">
              © Nhi Y. Ngo
            </h6>
            <p class="text-xs sm:text-sm text-flax-smoke-500 mt-1 text-center md:text-left whitespace-nowrap">
              UI by Huy Nguyen
            </p>
            <p class="text-xs sm:text-sm text-flax-smoke-500 mt-1 text-center md:text-left hidden sm:block whitespace-nowrap">
              Adapted from Hetari
            </p>
            <p class="text-xs sm:text-sm text-flax-smoke-500 mt-1 text-center md:text-left sm:hidden">
              Adapted from Hetari
            </p>
          </div>

          <div
            class="hidden md:flex md:col-span-5 md:flex-col"
          >
            <p class="text-sm sm:heading-6 font-bold uppercase whitespace-nowrap">Toronto Time</p>
            <p class="text-sm sm:heading-6 whitespace-nowrap">{{ myLocalTime }}</p>
            <p class="text-sm sm:heading-6 font-bold uppercase whitespace-nowrap">Your Local time</p>
            <p class="text-sm sm:heading-6 whitespace-nowrap">{{ userLocalTime }}</p>
          </div>

          <div
            class="hidden md:block absolute -right-4"
          >
            <MagneticEffect divId="scroll-to-top" textId="scroll-to-top-icon">
              <div
                @click="lenis.scrollTo('#app', { duration: 2 })"
                id="scroll-to-top"
                class="flex-center bg-flax-smoke-400 size-20 cursor-pointer flex-col rounded-full"
              >
                <svg
                  class="size-1/2"
                  id="scroll-to-top-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  color="#000000"
                  fill="none"
                >
                  <path
                    d="M12 4L12 20"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.9998 8.99996C16.9998 8.99996 13.3174 4.00001 11.9998 4C10.6822 3.99999 6.99982 9 6.99982 9"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </MagneticEffect>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { resourceLinks, socialLinks } from '@/data';
  import { Link } from '..';
  import { onMounted, ref } from 'vue';
  import { lenis } from '@/main';
  import MagneticEffect from '../MagneticEffect.vue';
  import moment from 'moment-timezone';

  const myLocalTime = ref('');
  const userLocalTime = ref('');

  onMounted(() => {
    // Toronto Time (local to you)
    myLocalTime.value = moment.tz('America/Toronto').format('h:mm:ss a');
    setInterval(() => {
      myLocalTime.value = moment.tz('America/Toronto').format('h:mm:ss a');
    }, 1000);

    // User's local time (based on their location)
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    userLocalTime.value = moment.tz(userTimeZone).format('h:mm:ss a');
    setInterval(() => {
      userLocalTime.value = moment.tz(userTimeZone).format('h:mm:ss a');
    }, 1000);
  });
</script>
